import AddVehicles from 'components/Vehicles/AddVehicles/AddVehicles'
import React, { Component } from 'react'

export default class AddVehiclesContainer extends Component {
  render() {
    return (
        <>
      
       <AddVehicles/>
       </>
    )
  }
}
